//components
import { Container } from '@/components/Grid';
import {
  Section,
  Kicker,
  KickerDot,
  SectionTitle,
  SectionLede,
  Grad,
} from '@/containers-ai/SectionHeading';

import { FreightExperts } from '@/containers-ai/FreightExperts';
import { PillLink } from '@/containers-ai/Buttons';
import { CountUp } from '@/containers-ai/CountUp';

import {
  PlatformScale,
  platformScaleStats,
} from '@/containers-ai/PlatformScale';

//data
import { agents, stages } from '../../agents';

//styles
import {
  AutomateSection,
  Head,
  Proof,
  ProofValue,
  ProofText,
  Group,
  GroupLabel,
  Row,
  RowStat,
  RowStatValue,
  RowStatLabel,
  RowTitle,
  RowText,
  ReadMore,
  CustomBand,
  CustomTitle,
  CustomCopy,
} from './LiveInProduction.styles';

// "What we automate": the detail behind The lineup, grouped by the same four
// lifecycle stages, followed by the Freight Experts block and the platform
// numbers.
export function LiveInProduction() {
  return (
    <>
      <AutomateSection id="automate">
        <Container>
          <Head>
            <div>
              <Kicker>
                <KickerDot />
                What we automate
              </Kicker>
              <SectionTitle style={{ maxWidth: '905px' }}>
                The repetitive work that eats your team&rsquo;s day. <br />
                <Grad>We take it off your plate.</Grad>
              </SectionTitle>
              <SectionLede style={{ maxWidth: '520px' }}>
                Every shipper runs the same manual tasks over and over.
                Loadsmart AI automates the tasks, end-to-end.
              </SectionLede>
            </div>
            <Proof>
              <ProofValue>
                <CountUp value={3000} />+
              </ProofValue>
              <ProofText>
                real TMS objects orchestrated in production by Loadsmart AI
              </ProofText>
            </Proof>
          </Head>

          {stages.map((stage) => (
            <Group key={stage.id} id={`stage-${stage.id}`}>
              <GroupLabel>
                <i />
                <h3>{stage.label}</h3>
              </GroupLabel>
              <div>
                {stage.slugs.map((slug) => {
                  const agent = agents[slug];

                  return (
                    <Row key={slug} id={`agent-${slug}`}>
                      <RowStat>
                        <RowStatValue>{agent.metric}</RowStatValue>
                        <RowStatLabel>{agent.label}</RowStatLabel>
                      </RowStat>
                      <div>
                        <RowTitle>{agent.title}</RowTitle>
                        <RowText>{agent.description}</RowText>
                      </div>
                      <ReadMore href={`/ai/${slug}/`}>
                        READ MORE &#8594;
                      </ReadMore>
                    </Row>
                  );
                })}
              </div>
            </Group>
          ))}

          <CustomBand id="custom">
            <div>
              <Kicker>
                <KickerDot />
                Custom &mdash; anything else
              </Kicker>
              <CustomTitle>
                If you can describe the task, we&rsquo;ll build the agent to run
                it.
              </CustomTitle>
              <CustomCopy>
                Bring the repetitive, rules-based work that eats your team’s day
                and we’ll build a custom agent for it.
              </CustomCopy>
            </div>
            <PillLink
              href="/contact/#contact-form"
              className="qlf-btn-2"
              style={{ whiteSpace: 'nowrap' }}
            >
              Book a working session &#8594;
            </PillLink>
          </CustomBand>
        </Container>
      </AutomateSection>

      <Section id="operators-and-scale">
        <Container>
          <FreightExperts border={false} as="div" />
          <PlatformScale stats={platformScaleStats} />
        </Container>
      </Section>
    </>
  );
}
